import { render, staticRenderFns } from "./TwoColumnLayout.vue?vue&type=template&id=a976c41c"
import script from "./TwoColumnLayout.vue?vue&type=script&lang=js"
export * from "./TwoColumnLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports